/**
 * @ngdoc directive
 * @name Menu Navigation
 *
 * @description
 Make project navigation
 */

(function () {
  menuNav.$inject = ["$window", "$rootScope", "localStorageService", "personService", "permissionService", "PATH", "MENU_NAVIGATION", "SCREENSIZE", "$timeout", "screenSizeService", "apiService", "alertService", "$modal"];
  app.directive('menuNav', menuNav);

  function menuNav(
    $window,
    $rootScope,
    localStorageService,
    personService,
    permissionService,
    PATH,
    MENU_NAVIGATION,
    SCREENSIZE,
    $timeout,
    screenSizeService,
    apiService,
    alertService,
    $modal
  ) {
    var directive = {
      restrict: 'E',
      scope: true,
      templateUrl: PATH.components + 'menuNav/template.tpl.html',
      link: link
    };

    return directive;

    function link($scope) {
      var isSafari = navigator.userAgent.indexOf('Safari') > -1;
      var delayToRedirect = 50;
      var isMobileView = screenSizeService.smallerThan('sm');
      var nav = MENU_NAVIGATION;
      $scope.accounts = [];
      $scope.selectedAccount;
      $scope.search = {
        searchField: '',
      };
      $scope.state = {};
      $scope.areAccountDetailsAllowed = permissionService.isAllowed({
        role: 'superAdmin',
        resource: 'accountdetails'
      });
      $scope.shouldShowDisabled = { result: false };
      $scope.accountSearchFields = [];
      $scope.isMobile = screenSizeService.smallerThan('sm');
      init();

      function loadAccounts() {
        apiService.getSome('company')
          .then(function (response) {
            var data = response.data;
            // in cases when user is not superuser this api returns only his company
            // usual user shouldn't have permissions for this page at all
            // so we have to think about the way to remove it
            if (!Array.isArray(data)) {
              // eslint-disable-next-line no-param-reassign
              data = [data];
            }
            $scope.accounts = data;

            $scope.accounts.forEach(function (item) {
              item.searchField = item.caption + ' (' + item.id + ')';
            });
            $scope.setAccountSearchFields();
          }, function (reason) {
            alertService.error(reason.data[0].errorMessage);
            // add redirect?
          });
      }

      $scope.$on('$typeahead.select', function (event, value) {
        $scope.selectedAccount = _.find(getAccounts(), { searchField: value });
        $scope.$apply();
      });

      $scope.clearSelectedAccount = function () {
        $scope.selectedAccount = null;
      };

      $scope.goToAccount = function () {
        localStorageService.set('userInfo', $scope.userInfo);
        $scope.state.result = 'details';
      };

      $scope.slideIn = function () {
        $scope.loading = true;
        personService.slideIn(
          {
            login: $scope.userInfo.login,
            companyid: $scope.selectedAccount.id,
            role: $scope.userInfo.role,
            id: $scope.userInfo.id
          },
          { id: $scope.selectedAccount.primaryUserId }, null, 'notes');
      };

      $scope.setAccountSearchFields = function () {
        $scope.accountSearchFields = _.map(getAccounts(), 'searchField');
      };

      function getAccounts() {
        return $scope.shouldShowDisabled.result ? $scope.accounts : _.filter($scope.accounts, { deleted: false });
      }

      function init() {
        localStorageService.bind($scope, 'userInfo');
        if (!$scope.userInfo.slidenIn) loadAccounts();
        var availableStores = $scope.userInfo.availableStores.filter(function (store) {
          if (store.contact.address) return store.contact.address;
          if (store.caption) return store.caption;
        });
        $scope.hasAvalaibleStores = availableStores.length > 0;
        if (!$scope.hasAvalaibleStores && $scope.userInfo.currentStore) {
          var result = $scope.userInfo.companies.filter(function (company) {
            if (company.id === $scope.userInfo.currentStore.companyId) {
              return company;
            }
          });
          if (result.length > 0) {
            $scope.userInfo.currentStore.caption = result[0].caption;
          }
        }
        $scope.nav = getAllowedLinks(nav);
        $scope.fakeMobileBg = false;
        $scope.openedTab = {
          item: getOpenedLink($scope.nav)
        };
        $scope.title = $rootScope.title || $scope.openedTab.item && $scope.openedTab.item.title || 'My Profile';
        listenToShortcuts($scope.nav);
      }

      $rootScope.$on('updateStores', function () {
        $scope.userInfo.availableStores = localStorageService.get('userInfo').availableStores;
        $scope.userInfo.currentStore = localStorageService.get('userInfo').currentStore;
      });

      // fixes bootstrap bug
      // when selecting current url in navigation
      // navigation is not closing
      $scope.goTo = function (url, $event, safe) {
        if (safe) {
          localStorageService.set('currentStore', $scope.userInfo.company);
        }
        if (!url.includes('notes')) {
          if (isSafari) {
            $scope.fakeMobileBg = true;
            $scope.setNavVisibility(!$scope.isNavVisible, $event);
            $timeout(function () {
              $window.location.href = url;
            }, delayToRedirect);

            return false;
          }
          $window.location.href = url;
        } else if (!$scope.userInfo.currentStore.id && url.includes('notes')) {
          $scope.$evalAsync(function () {
            $scope.modal = $modal({
              scope: $scope,
              templateUrl: PATH.apps + 'accountmanagement/slideinmodal.html'
            });
          });
        } else if ($scope.userInfo.currentStore.id && url.includes('notes')) {
          $window.location.href = url;
        }
      };


      $scope.openUploadModal = function () {
        $scope.modal = $modal({
          scope: $scope,
          templateUrl: PATH.apps + 'accountmanagement/upload.html'
        });
      };

      $scope.cancel = function () {
        $scope.modal.hide();
      };

      $scope.setNavVisibility = function (value, $event) {
        $scope.isNavVisible = value;
        if ($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      };

      $scope.goToStore = function (store, isMultipleCompaniesUser) {
        personService.switchStore(store, isMultipleCompaniesUser);
      };

      $scope.signOut = function ($event) {
        if (isSafari && isMobileView) {
          $scope.setNavVisibility(!$scope.isNavVisible, $event);
          $timeout(function () {
            personService.logOut();
          }, delayToRedirect);

          return false;
        }
        personService.logOut();
      };

      $scope.slideOut = function ($event) {
        if (isSafari && isMobileView) {
          $scope.setNavVisibility(!$scope.isNavVisible, $event);
          $timeout(function () {
            personSlideOut();
          }, delayToRedirect);

          return false;
        }
        personSlideOut();
      };

      function personSlideOut() {
        var user = angular.copy($scope.userInfo);
        personService.slideOut(user);
      }

      function getAllowedLinks(links) {
        return _.filter(links, function (item) {
          var hasAllowedSubItem;
          var isVisible;

          _.forEach(item.hiddenitems, function (subitem) {
            hasAllowedSubItem = permissionService.isAllowed(subitem.permissions);
          });
          isVisible = hasAllowedSubItem || item.permissions && permissionService.isAllowed(item.permissions);
          return isVisible;
        });
      }

      function getOpenedLink(links) {
        // make hardcoded url look like normal
        var openedUrl = $window.location.pathname
          .replace(PATH.apps, '')
          .replace('/index.html', '')
          .replace('/', '');

        return _.find(links, function (item) {
          return openedUrl === item.url || _.find(item.hiddenitems, function (subitem) {
            return openedUrl === subitem.url;
          });
        });
      }

      function listenToShortcuts(links) {
        var isAdminPageOpened = $scope.userInfo ? $scope.userInfo.isAdmin : false;
        var isMobile = $window.innerWidth < SCREENSIZE.sm;
        if (isAdminPageOpened || isMobile) return;

        $scope.keysPressed = [];
        document.addEventListener('keydown', function (event) {
          if (event.altKey) {
            $scope.keysPressed.push(event.keyCode || event.charCode);
            document.addEventListener('keydown', openShortCut);
          }
        });

        function openShortCut() {
          var linkShortCut = $scope.keysPressed.length && _.find(links, function (linkObject) {
            var hotKeys = linkObject.keycode;
            var keyPressedWithAlt = $scope.keysPressed[1];
            return _.find(hotKeys, function (hotKey) {
              return hotKey === keyPressedWithAlt;
            });
          });

          if (linkShortCut) {
            $window.location.href = linkShortCut.url;
          } else {
            $scope.keysPressed = [];
            document.removeEventListener('keydown', openShortCut);
          }
        }
      }
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/menuNav/menuNavDirective.js